<template>
  <div class="download">
    <!-- banner -->
    <banner content="心闻资讯心闻资讯心闻资讯心闻资讯" title="心闻资讯" type='10'/>
    <!-- 导航栏 -->
    <div v-if="width >= 1200" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="参观指导" name="1"></el-tab-pane>
        <el-tab-pane label="前沿动态" name="2"></el-tab-pane>
        <el-tab-pane label="学术交流" name="3"></el-tab-pane>
        <el-tab-pane label="实践在线" name="4"></el-tab-pane>
        <!-- <el-tab-pane label="关心关爱" name="5"></el-tab-pane> -->
        <el-tab-pane label="信息发布" name="5"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 导航栏 -->
    <div v-if="width <= 768" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="参观指导" name="1"></el-tab-pane>
        <el-tab-pane label="前沿动态" name="2"></el-tab-pane>
        <el-tab-pane label="学术交流" name="3"></el-tab-pane>
        <el-tab-pane label="实践在线" name="4"></el-tab-pane>
        <el-tab-pane label="信息发布" name="5"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- body -->
    <div v-if="width >= 1200" class="guidance">
      <div class="guidanceBody">
        <div v-for="(item,index) in guidanceList" style="cursor: pointer;" :key="index" class="guidancebox" @click="goDetail(item)">
          <img :src="imgserver+item.coverUrl" alt="" style="border-radius: 10px">
          <el-tooltip class="item" effect="dark"  :content="item.title" placement="bottom-start">
          <div class="content" >{{item.title}}</div>
          </el-tooltip>
          <div class="news">{{ item.createTime }}</div>
        </div>
      </div>
      <div class="block">
        <el-pagination
            :current-page="query.pageNum"
            :page-size="query.pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <div v-if="width <= 768" class="guidance">
      <div class="guidanceBody">
        <div v-for="(item,index) in guidanceList" :key="index" class="guidancebox" @click="goDetail(item)">
          <img :src="imgserver+item.coverUrl" alt="" style="border-radius: 10px">
          <div class="content">{{ item.title }}</div>
          <div class="news">{{ item.createTime }}</div>
        </div>
      </div>
      <div class="block">
        <el-pagination
            :current-page="query.pageNum"
            :page-size="query.pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {getnewsMessage} from "../api/api";

export default {
    components: {
        Banner,
    },
    data () {
        return {
            activeName:'1',
            guidanceList:[],
            currentPage4: 4,
            type:1,
            query:{
                pageNum:1,
                pageSize:6,
            },
            total:0,
            width:""
        }
    },
    mounted () {
      if(this.$route.query.index){
        this.activeName = this.$route.query.index
        this.type = this.activeName
        // console.log(this.activeName,' this.activeName');
      }
      let that = this
      window.addEventListener("resize", function (e) {
        that.width = e.target.document.documentElement.clientWidth
      });
        this.onload()
    },
    methods: {
        onload(){
            getnewsMessage({...this.query,type:this.type}).then(res => {
                this.guidanceList = res.data.rows
                // console.log(res.data.rows,'this.guidanceList');
                this.total = res.data.total
            })
        },
        handleClick(tab){
            // this.type = tab.name
            // console.log(this.activeName,' this.activeName');
            this.type = this.activeName
            getnewsMessage({...this.query,type:this.type}).then(res => {
                this.guidanceList = res.data.rows
                this.total = res.data.total
            })
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.query.pageSize = val;
            this.onload()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.query.pageNum = val
            this.onload()
        },
        //跳转详情
        goDetail(item){
            // console.log(item,'iiiii');
            this.$router.push({
                path:'/consultationDetails',
                query:{
                    id:item.articleId,
                    type:item.type
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.download {
  width: 100%;
  height: 100%;
}

::v-deep .el-tabs__item {
  color: #666666 !important;
}

//公共样式
.title,
.eTitle {
  font-size: 30px;
  font-weight: normal;
  line-height: 50px;
  letter-spacing: 0px;
  color: #000000;
}

.eTitle {
  font-size: 30px;
  padding: 10px 0;
}

//改tab
.nav {
  width: 100%;
  // padding: 20px 0 0 0;
  height: 50px;
  line-height: 50px;
  box-shadow: 0px 4px 10px 0px #E9F5F9;
  margin-bottom: 20px;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none !important;
  background-color: #fff !important;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
}

::v-deep .el-tabs__nav-scroll {
  width: 1440px;
  margin: 0 auto;
}

//结束
::v-deep .el-tabs--card {
  border: 0 !important;
}

::v-deep .el-tabs__item .is-active {
  color: #34A59A !important;
}

::v-deep .el-tabs__item:hover {
  color: #333333 !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #fff !important;
  color: #34A59A !important;
  border-bottom-color: transparent !important;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

@media (min-width: 1200px) {
  .guidance {
    width: 1440px;
    margin: 0 auto;
    // height: 120vh;
    box-sizing: border-box;
    padding: 50px 0;

    .guidanceBody {
      width: 100%;
      // height: 90vh;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 3;
    }

    .guidancebox {
      width: 400px;
      height: 400px;
      margin-bottom: 30px;
      cursor: pointer;
      img {
        width: 400px;
        height: 268px;
      }

      .content {
        font-size: 14px;
        font-weight: normal;
        line-height: 26px;
        letter-spacing: 0em;
        color: #002367;
        margin: 10px 0;
        //white-space: nowrap;//不支持换行
        //overflow: hidden;//隐藏多出部分文字
        //text-overflow: ellipsis;//用省略号代替多出部分文字
      }

      .news {
        font-size: 16px;
        font-weight: normal;
        line-height: 16px;
        color: #888888;

        span {
          font-size: 16px;
          font-weight: normal;
          line-height: 16px;
          color: #888888;
          display: inline-block;
          background: #EEEEEE;
          padding: 5px;
          margin-right: 20px;
        }
      }
    }

  }
  .block {
    text-align: center;
    margin-top: 50px;
  }
}

@media (max-width: 768px) {
  .etitle {
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
  }
  .nav {
    width: 100%;
    // padding: 20px 0 0 0;
    height: 50px;
    line-height: 50px !important;
    box-shadow: 0px 4px 10px 0px #E9F5F9;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none !important;
    background-color: #fff !important;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    height: 30px;
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    margin: 0 auto;
  }
  .guidance {
    // width: 1440px;
    // margin: 0 auto;
    // height: 120vh;
    width: 100%;
    padding: 15px;

    box-sizing: border-box;
    // padding:20px 0;
    .guidanceBody {
      width: 100%;
      // height: 90vh;
      // padding: 15px;

      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // flex: 3;
    }

    .guidancebox {
      // padding: 15px;
      border-radius: 4px;
      box-sizing: border-box;
      width: 100%;
      height: 325px;
      margin-bottom: 30px;

      img {
        width: 100%;
        height: 200px;
        border-radius: 4px;
      }

      .content {
        font-size: 12px;
        font-weight: normal;
        line-height: 32px;
        letter-spacing: 0em;
        color: #002367;
        margin: 10px 0;
        overflow: hidden;
      }

      .news {
        font-size: 12px;
        font-weight: normal;
        line-height: 16px;
        color: #888888;

        span {
          font-size: 12px;
          font-weight: normal;
          line-height: 16px;
          color: #888888;
          display: inline-block;
          background: #EEEEEE;
          padding: 5px;
          margin-right: 20px;
        }
      }
    }

  }
  .block {
    text-align: center;
    margin-top: 0px;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #34A59A !important;
}

</style>
